import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  InputGroupAddon,
  InputGroup,InputGroupText,Input
} from "reactstrap";
import {
  Link
} from "react-router-dom";


import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { connectorsTypeLogo } from '../../settings/shared/commonMethod';
import { Scrollbars } from 'react-custom-scrollbars';


// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";


const connectorData = [
  {
  name:"Snowflake",
  topic:"CRM"
  },
  {
    name:"MongoDB",
    topic:"Database"
    },
  {
    name:"AmazonS3",
    topic:"AWS"
  },
  {
    name:"DataLake",
    topic:"Azure",
  }
]

class ChooseConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectorList:connectorData,
      swidth: window.innerWidth,
      sheight: window.innerHeight
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }
  componentDidMount() {
    localStorage.removeItem("selectConnectorType");
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
 }
 componentWillUnmount() {
  window.removeEventListener('resize', this.updateWindowDimensions);
}

updateWindowDimensions() {
  this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
}
 onChangeConnector = (value) =>{
  // console.log(this.state.chatprojectdataFilterData
     if(value === ""){
       this.setState({
       connectorList:connectorData,
       searchKey:value
     })
     }else{
     const filteredUsers = connectorData.filter(item => item.name.toString().toLowerCase().includes(value.toLowerCase()));
     this.setState({
      connectorList:filteredUsers,
      searchKey:value
     })
     }  
}


 ClickConnectorType = (type) =>{
   localStorage.setItem("selectConnectorType",type);
   this.props.history.push({
    pathname: '/connectors/NewConnection/',
    state: { mode: "fromChooseConnector"}
  })
 }
 

  
  render() {
    return (
   
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
              <CardHeader>
                  <Row className="align-items-center">
                    <div className="col">
                     <h5 className="mb-0">Available Connectors</h5>
                    </div>
                    <div className="col">
                      <InputGroup className="no-border" style={{border: "1px solid #d3d3d3"}}>
                      <Input placeholder="Search Connector" onChange={event => this.onChangeConnector(event.target.value)}
                          value={this.state.jobSearch} style={{color: 'black',height:'30px',fontSize:'14px',backgroundColor:'#fff'}}/>
      
                      <InputGroupAddon addonType="append" style={{backgroundColor:'#fff', borderRadius:'5px',height: '30px'}}>
                        <InputGroupText style={{backgroundColor:'#fff', borderRadius:'5px',height: '30px'}}>
                          &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    </div>
                    <div className="col text-right">
                    <Link to={{
                        pathname: '/connectors/NewConnection',
                        state: { mode:"fromChooseConnector" }
                      }}> 
                    <span class="close clear-filter">×</span>                     
                      </Link>  
                    </div>
                  </Row>
               </CardHeader>
                <CardBody>

                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>

            <Row className="mt-12">
              <Col className="mb-12 mb-xl-0" xl="12">
                <div className="table-responsive">
                    <Row className="icon-examples" style={{marginTop:10}}>

                     {this.state.connectorList.map((item, index) => (<Col sm={2} xs={12} className="gridSize_Connector" onClick={e => this.ClickConnectorType(item.name)}>
                          <Col className="text-center" lg="12" md="12" >
                          <div className="grid-Connector"><img src={connectorsTypeLogo(item.name)} alt="ConnectorImage" />
                          <div className="grid-desc">{item.name}</div>
                          <div className="connector_topic">{item.topic}</div>
                          </div>
                            {/* <Card className="card-contributions hoverconnector" onClick={e => this.ClickConnectorType(item.name)}>
                              <CardBody>
                                <Row>
                                  <Col xs="12" className="overflowStyle">
                                  
                                    <img src={item.image} style={{width:50,height:50}}alt="Snowflakes" />
                                  
                                  <div className="grid-desc">{item.name}</div>
                                  <div className="connector_topic">{item.topic}</div>
                                  <hr></hr>
                                  <div className="block-with-description"><span title={item.description}>{item.description}</span></div>
                                  </Col>
                                </Row>
                                
                              </CardBody>
                            </Card> */}
                          </Col>
                      </Col>))}
                      
                    </Row>
              
                </div>  
              </Col>
            </Row>
            {this.state.connectorList.length === 0 && <Row>
              <Col>
              <span>No Results for "{this.state.searchKey}"</span>
              </Col>
              </Row>}
              </Scrollbars>

              </div>

              </CardBody>
              </Card>
            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default ChooseConnector;
